export type PSTNObject = {
  allNumbers: Array<PstnNumber>;
  customNumbers: Array<PstnNumber>;
};
export interface PstnNumber {
  id: string;
  countryCode: string;
  phoneNumber: string;
  value?: string;
}

export const fetchPSTNUrl = process.env.REACT_APP_PSTN_URL || '';

export const getPstnOptions = (pstnObject?: PSTNObject): PSTNObject => {
  const customNumbersInput = pstnObject?.customNumbers || [];
  const allNumbersInput = pstnObject?.allNumbers || [];

  const customNumbers = customNumbersInput
    .filter((pstnNumber) => pstnNumber.phoneNumber)
    .map((pref: PstnNumber) => {
      return {
        ...pref,
        icon: `/flags/${pref?.countryCode?.toLowerCase()}.svg`,
        label: pref.phoneNumber,
        value: pref.id
      };
    });
  const allNumbers = allNumbersInput
    ?.filter((pstnNumber) => pstnNumber.phoneNumber)
    .map((pref: PstnNumber) => {
      return {
        ...pref,
        icon: `/flags/${pref?.countryCode?.toLowerCase()}.svg`,
        label: pref.phoneNumber,
        value: pref.id
      };
    });

  return { allNumbers, customNumbers };
};

export const getPSTNData = async (groupUUID: string) => {
  const url = `${fetchPSTNUrl}${groupUUID}`;
  const response: { error?: string; pstnNumbers: PSTNObject } = {
    error: undefined,
    pstnNumbers: { allNumbers: [], customNumbers: [] }
  };
  if (!groupUUID) return response;
  try {
    const data = await fetch(url);
    response.pstnNumbers = await data.json();
    return response;
  } catch (error) {
    response.error = error;
    return response;
  }
};
